import { CardioOrResistance } from 'fitbeat.models';
import { ActivityType } from '../../entities';

export class CardioOrResistanceActivityTypeMapping {
  public static getCardioOrResistanceForActivityType(
    activityType: ActivityType,
    activityTypeMap: Map<ActivityType, CardioOrResistance[]>,
  ): CardioOrResistance {
    const mappings = activityTypeMap.get(activityType);
    if (!mappings || mappings.length === 0) {
      throw new Error(`No cardio or resistance found for activity type: ${activityType}`);
    }
    return mappings[0];
  }

  public static buildActivityTypeMap(): Map<ActivityType, CardioOrResistance[]> {
    const mapping = new Map([
      [ActivityType.BuildFitillion, [CardioOrResistance.Resistance]],
      [ActivityType.BurnFitillion, [CardioOrResistance.Cardio]],
      [ActivityType.BalanceFitillion, [CardioOrResistance.Balance]],
      [ActivityType.BoxingFitillion, [CardioOrResistance.Cardio]],
      [ActivityType.PowerStationFitillion, [CardioOrResistance.Resistance]],
      [ActivityType.TreadmillFitillion, [CardioOrResistance.Cardio]],
      [ActivityType.StudioBikeFitillion, [CardioOrResistance.Cardio]],
      // imported
      [ActivityType.Stepper, [CardioOrResistance.Cardio]],
      [ActivityType.Running, [CardioOrResistance.Cardio]],
      [ActivityType.Climbing, [CardioOrResistance.Resistance]],
      [ActivityType.PilatesAndYoga, [CardioOrResistance.Balance]],
      [ActivityType.Elliptical, [CardioOrResistance.Cardio]],
      [ActivityType.Cycling, [CardioOrResistance.Cardio]],
      [ActivityType.StrengthTraining, [CardioOrResistance.Resistance]],
      [ActivityType.OtherCardio, [CardioOrResistance.Cardio]],
      [ActivityType.Swimming, [CardioOrResistance.Cardio]],
      [ActivityType.Multisport, [CardioOrResistance.Cardio]],
      [ActivityType.HIIT, [CardioOrResistance.Cardio]],
      [ActivityType.Gymnastics, [CardioOrResistance.Resistance]],
      [ActivityType.WinterSports, [CardioOrResistance.Cardio]],
      [ActivityType.WalkingAndHiking, [CardioOrResistance.Cardio]],
      [ActivityType.RacquetSport, [CardioOrResistance.Cardio]],
      [ActivityType.RowingAndPaddling, [CardioOrResistance.Cardio]],
      [ActivityType.TeamSports, [CardioOrResistance.Cardio]],
      [ActivityType.DanceAndAerobics, [CardioOrResistance.Cardio]],
      [ActivityType.CombatAndMartialArts, [CardioOrResistance.Resistance]],
    ]);
    CardioOrResistanceActivityTypeMapping.validateOnlyOneCardioOrResistancePerActivityType(mapping);
    return mapping;
  }

  private static validateOnlyOneCardioOrResistancePerActivityType(
    activityTypeMap: Map<ActivityType, CardioOrResistance[]>,
  ): void {
    for (const [activityType, mappings] of activityTypeMap.entries()) {
      if (mappings.length > 1) {
        throw new Error(`Activity type ${activityType} has multiple mappings: ${mappings.join(', ')}`);
      }
    }
  }
}
